var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 9.88867C8.50586 9.88867 8.17773 9.76562 7.93164 9.51953L1.36914 2.95703C0.835938 2.46484 0.835938 1.60352 1.36914 1.11133C1.86133 0.578125 2.72266 0.578125 3.21484 1.11133L8.875 6.73047L14.4941 1.11133C14.9863 0.578125 15.8477 0.578125 16.3398 1.11133C16.873 1.60352 16.873 2.46484 16.3398 2.95703L9.77734 9.51953C9.53125 9.76562 9.20312 9.88867 8.875 9.88867Z",
    fill: "#4B4B4B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.fb4ee76f09a6f21115182bf5be2374a4.svg";
export { ForwardRef as ReactComponent };